import { useOnlineStatus } from "../../hooks/useOnlineStatus";

export default function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-warning-500 px-4 py-2 text-center text-sm font-medium text-white shadow-md">
      You are offline. Some features may be unavailable.
    </div>
  );
}
